module.exports = __webpack_public_path__ + "img/end-call.87836cda.png";